<script>
  	import { createEventDispatcher } from "svelte";
    export const dispatch = createEventDispatcher();

    export let title;
    export let boardID;
    export let size;

    export let selectedBoard;

    function changeBoard(id) {
      // selectedBoard = boardID
      dispatch("update", {
        selected: id,
        title: title,
      });
    }
</script>

<div class="boardItem" id={boardID} on:click={()=>changeBoard(boardID)}>
  <p>{title}</p>
</div>

<style>
  .boardItem{
    background-color: #90898E;
    color:#2B2C2E;
    /* width: 100%; */
    border-radius: 8px;
    padding: 12px;
    padding-top: 150px;
    margin-bottom: 2px;
    transition: all 0.2s;
    cursor: pointer;
    display: flex;
    justify-content: space-between
  }
  .boardItem:hover{
    background-color: black;
    color: #DDDEDF;
  }

  .deleteButton{
    background: tomato;
    /* color: white; */
    color: rgb(100, 45, 35);
    border-radius: 20px;
    border: 1px solid tomato;
    transition: all 0.2s;
    cursor: pointer;
  }
  .deleteButton:hover{
    background-color: transparent;
    color: tomato;
  }
</style>